// the cookies module only: cypress imports these constants
import {cookieNamesForDomain} from "../shared/session/cookies";

interface RoutesItem {name: string; href: string; icon: string;}

export const routes: RoutesItem[] = [
    {name: "Resolution Requests", href: "/request-list", icon: "request"}
];

// session cookies: the names come from the shared session package (the
// stage prefix follows the cookie parent domain: integ_, preprod_, prod_)
export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME;
const SESSION_COOKIES = cookieNamesForDomain(DOMAIN_NAME);

export const ACCESS_TOKEN_KEY = SESSION_COOKIES.idToken;
export const COOKIES_COMPANY_ID: string = SESSION_COOKIES.companyId;
export const COOKIES_USER_ID: string = SESSION_COOKIES.userId;
export const COOKIES_USER_ROLE: string = "l5_userRole";
export const COOKIES_COMPANY_NAME: string = SESSION_COOKIES.companyName;
export const COOKIES_OTHER_APP_PROVISION: string = "fromProvision"; // from other app cookies
export const COOKIES_FROM_PROVISION: string = "fromProvisionTMU"; // from fleet cookies
export const COOKIES_LP: string = "trailerLp";
export const COOKIES_TRAILER_ID: string = "trailerId";
export const COOKIES_TMU_ID: string = "tmuId";
export const AFTER_VERIFICATION: string = "verification_next_step";
export const ACCOUNT_VERIFY_IDENTITY = `${process.env.REACT_APP_ACCOUNT_APP}/account-settings/verify-identity`;

export const PAGE_LIMIT = 15;
export const USER_EMAIL = "admin3@maeu.com";
export const ACCESS_LINK = {
    apple: "https://apps.apple.com/be/app/admiral-access/id6502579460",
    google: "https://play.google.com/store/apps/details?id=corp.l5fleet.utf" +
    "&hl=en_CA"
};
export const WEBSOCKET_CLIENT_ACTIONS = {
    fetchActiveChats: "fetchActiveChatMessages",
    fetchArchivedChats: "fetchArchivedChatMessages",
    fetchIntents: "fetchIntents",
    fetchNewChatMessages: "fetchNewChatMessages",
    sendMessage: "sendMessage",
    readMessage: "readMessage",
};

export const WEBSOCKET_RESPONSE_TYPE = {
    allChatMessages: "activeChatMessages",
    archivedChats: "archivedChatMessages",
    assignmentRequestVerified: "resolverUpdated",
    cancellationRequestVerified: "requestCancelled",
    chatArchived: "chatArchived",
    creationRequestVerified: "requestCreated",
    identityVerified: "identityVerified",
    intentsRetrieved: "intentsRetrieved",
    intentRevoked: "intentRevoked",
    newChatCreated: "newChatCreated",
    messageSent: "newRequestMessages",
    newMessage: "newMessage",
    readMessage: "readMessage",
    resolutionVerified: "requestResolved",
};

export const COMPANY_ROLE = {
  shipper: "shipper",
  carrier: "carrier",
  consignee: "consignee",
};
export const METRICS_URL = `${process.env.REACT_APP_API_URL}/public/emit-event`;
export const SESSION_ID_KEY = "s_id";
